import classNames from 'classnames'
import type { FC } from 'react'
import styles from './Chip.module.scss'
import type { ChipProps } from './types'
import { ChipVariant } from './types'

const Chip: FC<ChipProps> = ({
  className,
  leadingAccessory,
  trailingAccessory,
  text,
  selected = false,
  disabled = false,
  variant = ChipVariant.primary,
  rtl,
  children,
  badge,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={classNames(styles['pintxo-chip'], className)}
      data-variant={variant}
      data-disabled={disabled}
      data-selected={selected}
      data-rtl={rtl}
      {...rest}
      onClick={onClick}
      type="button"
    >
      {leadingAccessory && (
        <div className={styles['pintxo-chip__leading-accessory']}>{leadingAccessory}</div>
      )}
      <span className={classNames(styles['pintxo-chip__text'], 'pintxo-typography-body2-emphasis')}>
        {text}
        {children}
      </span>
      {badge && selected && <span className={styles['pintxo-chip__badge']}>{badge}</span>}
      {trailingAccessory && (
        <div className={styles['pintxo-chip__trailing-accessory']}>{trailingAccessory}</div>
      )}
    </button>
  )
}

export default Chip
